var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decorate"},[_c('div',{staticClass:"decorate-head"},[_vm._v(" "+_vm._s(_vm.title)+" --- 组件属性设置 ")]),_c('div',{staticClass:"decorate-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }